"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const systems_1 = require("@/store/ducks/systems");
const selectors_1 = require("@/store/ducks/systems/selectors");
const selectors_2 = require("@/store/ducks/sites/selectors");
const createSystemUseCase_1 = __importDefault(require("@/useCases/systems/createSystemUseCase"));
const schema_1 = require("../schema");
const index_view_1 = __importDefault(require("../index.view"));
function openAddSystemModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isAddSystemtModalVisible = (0, react_redux_1.useSelector)(selectors_1.isAddSystemModalOpenSelector);
    const sitesOptions = (0, react_redux_1.useSelector)(selectors_2.sitesListOptionsSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isSavingSystemSelector);
    const selectedSite = (0, react_redux_1.useSelector)(selectors_1.selectedSiteOptionSelector);
    const onCloseModal = react_1.default.useCallback(() => {
        dispatch((0, systems_1.closeAddSystemModal)());
    }, [dispatch, systems_1.closeAddSystemModal]);
    const initialValues = {
        name: "",
        site: {
            value: selectedSite?.value,
            label: selectedSite?.label,
        },
    };
    const onSubmit = (values) => {
        (0, createSystemUseCase_1.default)({ name: values.name, siteId: values.site.value })(dispatch);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, enableReinitialize: true, validationSchema: schema_1.validationSchema, onSubmit: onSubmit }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { formTitle: "Add New System", onBlur: props.handleBlur, values: props.values, options: sitesOptions, setFieldValue: props.setFieldValue, onSubmit: props.handleSubmit, errors: props.errors, confirmActionText: "Add New System", touched: props.touched, isLoading: isLoading, onChange: props.handleChange, onClose: onCloseModal, isOpen: isAddSystemtModalVisible }));
    }));
}
exports.default = openAddSystemModal;
